import { Component, OnInit } from '@angular/core';
import {Api, User} from "../../providers";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-edit-post',
  templateUrl: './edit-post.page.html',
  styleUrls: ['./edit-post.page.scss'],
})
export class EditPostPage implements OnInit {
  public post:any
  constructor(public api:Api, public user: User, public modalController: ModalController) {

  }

  ngOnInit() {
  }
  async save(){
    const formData = new FormData();
    formData.append("userKey", this.user.account.userKey);
    formData.append("vr", this.user.account.version);
    formData.append("text", this.post.text);
    formData.append("pid", this.post.id);
    await this.user.myLoading()

    const upload$ = this.api.post("post/edit", formData).subscribe(mres => {
        this.user.checkStatus(mres,res=> {
            this.user.dismissLoading()
            this.dismissPost()
        },res=>{})
    },err=>{
      this.user.dismissLoading()
    });
  }
  public dismissPost() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true,
      'post': this.post,
    });
  }
}
